export default __webpack_public_path__ + "static/logo-text.inline-1695fdeac4319cb80d81babe2cc20bf3.png";